import { auth } from './firebase';

// Sign Up
export const createUserWithEmailAndPassword = (email, password) =>
    auth.createUserWithEmailAndPassword(email, password);

// Sign In
export const signInWithEmailAndPassword = (email, password) =>
    auth.signInWithEmailAndPassword(email, password);
// Sign out
export const doSignOut = () =>
    auth.signOut();
// Password Reset
export const passwordReset = (email) =>
    auth.sendPasswordResetEmail(email);

export const getUser = (user) => {
    return auth.onAuthStateChanged(user);
}

export const applyActionCode = (code) => {
    return auth.applyActionCode(code);
}
export const verifyPasswordResetCode = (code) => {
    return auth.verifyPasswordResetCode(code);
}

export const confirmPasswordReset = (actionCode, password) => {
    return auth.confirmPasswordReset(actionCode, password);
}

// Password Change
export const passwordUpdate = (password) =>
    auth.currentUser.updatePassword(password);


// WEBPACK FOOTER //
// ./src/firebase/auth.js